import { DateTime } from 'luxon';
import { getAppLanguage, type AppLanguageCode } from '@/i18n/languages';

const PLANNED_DATE_FORMAT_BY_LANGUAGE: Record<AppLanguageCode, string> = {
  fr: "cccc d LLLL 'à' HH'h'mm",
  en: "cccc, LLLL d 'at' h:mm a",
  es: "cccc d 'de' LLLL, HH:mm",
  pt: "cccc, d 'de' LLLL 'às' HH:mm",
};

export function formatPlannedLiveDate(
  utcPlannedDate: string | null | undefined,
  lang?: string,
): string {
  if (!utcPlannedDate) {
    return '';
  }
  try {
    const language = getAppLanguage(lang);
    const dt = DateTime.fromISO(utcPlannedDate, { zone: 'utc' })
      .setLocale(language.locale)
      .setZone(DateTime.local().zoneName);

    const base = dt.toFormat(PLANNED_DATE_FORMAT_BY_LANGUAGE[language.code]);

    return base.charAt(0).toUpperCase() + base.slice(1);
  } catch {
    return '';
  }
}
